$( document ).ready(function() {
    if ($('body').attr('id') == 'components') {
      $('.link-components-try-it-live').on('click', function () {
          dataLayer.push({
            'event': 'mjml',
            'eventValue': 'mjmlComponent-Clicked',
            'button': 'tryIt',
            'component': $(this).data('component')
          })
        });

       $('.link-components-doc').on('click', function () {
         dataLayer.push({
             'event': 'mjml',
             'eventValue': 'mjmlComponent-Clicked',
             'button': 'doc',
             'component': $(this).data('component')
         })
       });

       $('.border_templates img').on('click', function () {
          dataLayer.push({
            'event': 'mjml',
            'eventValue': 'mjmlComponent-Clicked',
            'button': 'image',
            'component': $(this).data('component')
       })
       });
    }
});
